import { Directive } from '@angular/core';

@Directive({
	selector: '[auiFooterBottom]',
})
export class FooterBottomDirective {}
